<company-responsible [companyId]="companyId" />